import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaClock } from "react-icons/fa";

const UNIT_LABELS = { s: "seconds", m: "minutes", h: "hours", d: "days" };

export default function AutomationDelayNode({ data, selected }) {
  const label = data.amount && data.unit
    ? `${data.amount} ${UNIT_LABELS[data.unit] || data.unit}`
    : data.duration || null;

  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${selected ? "border-amber-500 shadow-md" : "border-surface-border"}`}>
      <Handle type="target" position={Position.Top} className="!w-3 !h-3 !bg-amber-500 !border-2 !border-white" />
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]" style={{ background: "linear-gradient(135deg, #d97706, #f59e0b)" }}>
        <FaClock size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Delay</span>
      </div>
      <div className="px-3 py-2.5">
        {label ? (
          <p className="text-xs text-ink-primary font-medium">Wait {label}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Set delay duration...</p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-amber-500 !border-2 !border-white" />
    </div>
  );
}
